import { render, staticRenderFns } from "./ApplicantEditDocuments.vue?vue&type=template&id=08e155ef&"
import script from "./ApplicantEditDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicantEditDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports